module.exports = __webpack_public_path__ + "img/heart-fill.0a18475a.svg";